<template>
  <v-card class="pa-3 k-card-border card-filter-menu" elevation="0">
    <v-row>
      <v-col cols="6" class="my-auto">
        <h6>Filters</h6>
      </v-col>
      <v-col cols="6" class="text-right">
        <v-btn class="btn btn-sm btn-light" variant="text" size="x-small">Clear all</v-btn>
      </v-col>
    </v-row>
    <div class="my-3"></div>
    <v-card class="bg-light pa-2" elevation="0">
      <div>
        <v-row>
          <v-col cols="6"> <v-select v-model="orderByField" :items="orderByOptions" label="Order by" density="compact"
              variant="solo" item-title="label" item-value="value"
              @update:model-value="fetchTickets"></v-select></v-col>
          <v-col cols="6"> <v-select v-model="orderDirection" :items="['asc', 'desc']" label="Order direction"
              density="compact" variant="solo" @update:model-value="fetchTickets"></v-select></v-col>
        </v-row>

        <v-row>
          <v-col cols="12">

            <v-select v-model="status_id" :items="statuses" label="Status" density="compact" variant="solo"
              item-title="name" item-value="id" @update:model-value="fetchTickets"></v-select></v-col>

        </v-row>
      </div>



    </v-card>
    <div class="my-3"></div>
    <!-- <v-btn class="btn btn-sm btn-light" size="x-small" variant="outlined"><i class="fal fa-plus mr-right"></i> Add
      filter</v-btn> -->
  </v-card>
</template>


<script>
export default {
  props: {
    statuses: Array
  },

  data() {
    return {
      search: '',
      status_id: null,
      orderByField: "created_at", // Standaard volgorde
      orderDirection: "desc", // Standaard volgorde
      orderByOptions: [
        { label: "Status", value: "status_id" },
        { label: "IMAP Account ID", value: "imap_account_id" },
        { label: "Assigned To", value: "assigned_to" },
        { label: "Created At", value: "created_at" },
      ],
    };
  },

  methods: {
    fetchTickets() {
      this.$emit('fetch-tickets', {
        orderByField: this.orderByField,
        orderDirection: this.orderDirection,
        status_id: this.status_id
      });
    }
  },

  computed: {
    searchfilter: {
      get() {
        return this.search;
      },
      set(value) {
        this.$emit('update:search', value);
      }
    }
  }
};
</script>



<style>
.card-filter-menu h6 {
  font-size: 20px;
}
</style>